// このファイルは scripts/renewal/gen_site.py でモックアップから生成した。
// 文言・構成を直すときは、このファイルを直接編集してよい（再生成はしない）。
import { Link } from "react-router-dom";
import ContactBand from "../ContactBand";
import CasesBrowser from "../cases/CasesBrowser";

export default function CasesPage() {
  return (
    <main>
      <section className="page-hero ground" data-en="WORKS">
        <div className="container">
          <nav className="breadcrumb">
            <Link to="/">トップ</Link>
            <span>実績・事例</span>
          </nav>
          <h1 className="page-title">
            実績・事例<strong>Works</strong>
          </h1>
          <p className="page-lead">
            大企業から中小企業まで、AI・ブロックチェーンを活用したプロダクトの企画・開発を手がけてきました。
          </p>
        </div>
      </section>
      <section className="section works-list">
        <div className="container">
          <CasesBrowser />
        </div>
      </section>
      <section className="section ground">
        <div className="container">
          <h2 className="home-h2">
            <img src="/assets/icn_logo.svg" alt="" className="heading-icon" />
            主なお取引先<strong>Clients</strong>
          </h2>
          <ul className="client-grid">
            <li className="client-tile tile-ground">
              <img src="/assets/logos/logo-jtb.png" alt="JTB" />
            </li>
            <li className="client-tile tile-ground">
              <img
                src="/assets/logos/logo-jta.png"
                alt="JR東海エージェンシー"
              />
            </li>
            <li className="client-tile tile-ground">
              <img src="/assets/logos/logo-azism.png" alt="AZism" />
            </li>
            <li className="client-tile tile-ground">
              <img src="/assets/logos/logo-mics.png" alt="mics" />
            </li>
            <li className="client-tile tile-ground">
              <img
                src="/assets/logos/logo-consensusbase.png"
                alt="ConsensusBase"
              />
            </li>
            <li className="client-tile tile-ground">
              <img src="/assets/logos/logo-spicelink.png" alt="Spicelink" />
            </li>
            <li className="client-tile tile-ground">
              <img src="/assets/logos/logo-pizzaday.png" alt="PIZZA DAY" />
            </li>
            <li className="client-tile tile-ground">
              <img src="/assets/logos/logo-caramel.png" alt="Caramel" />
            </li>
          </ul>
        </div>
      </section>
      <ContactBand ground={false} />
    </main>
  );
}
